export const exception = {
    blacklistedRecruiter:
        'It is currently not possible to contact the talent due to their user settings.',
    unknown: 'An unknown error occurred.',
};
